import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isEmpty, cloneDeep } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import {
  uploadMultiPartFiles,
  getConfigUsagePlatforms,
  saveOutputTemplateByType,
  getOutputTemplateByType,
} from '../../../App/actions';
import TitleFrom from '../../../../components/common/TitleFrom';
import { UsagePrepaidConsumptionSearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  DragDropConfigExportTemplate,
  ModalWithItem,
} from '../../../../components/common';
import { tabelColumnExportUsagePrepaidConsumption, sortUsagePrepaidConsumption } from '../../constants';
import { getUsageConsumptionReport, getAllUsageConsumptionReport, onResetDefaultData } from '../../actions';
import { makeGetUsageConsumptionReport, makeGetListAllUsageConsumptionReport } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelFile';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfFile';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;

class UsagePrepaidConsumption extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {},
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listUsagePrepaidConsumption: [],
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listUsagePrepaidConsumption: props.listUsagePrepaidConsumption,
      totalCount: getPageTotalCount({ ...state, items: props.listUsagePrepaidConsumption }),
    };
  }

  componentDidMount() {
    const {
      permissions: { modeGetPrepaidConsumptionReport },
      onResetDefaultData,
    } = this.props;
    if (modeGetPrepaidConsumptionReport) {
      this.doGetOutputTemplateByType();
      onResetDefaultData('listUsageConsumptionReport');
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetListUsagePrepaidConsumption();
    });
  };

  onPageChange = pageChange => {
    const { page } = this.state;
    if (page === pageChange) return '';
    return this.setState({ page: pageChange }, () => this.doGetListUsagePrepaidConsumption());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetListUsagePrepaidConsumption());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetListUsagePrepaidConsumption();
    });
  };

  doGetListUsagePrepaidConsumption = () => {
    const { filter, page, size, sorted } = this.state;
    const { getUsageConsumptionReport } = this.props;
    const newFilter = cloneDeep(filter);
    if (!newFilter.startPeriod) {
      newFilter.startPeriod = moment().format('YYYY-MM');
    }
    const payload = {
      page: page + 1,
      size,
      filter: newFilter,
      sort:
        !isEmpty(sorted) && sortUsagePrepaidConsumption[sorted.sortCol]
          ? sortUsagePrepaidConsumption[sorted.sortCol][sorted.sortDir]
          : null,
    };
    this.setState({ isSearching: true });
    getUsageConsumptionReport(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAlllistUsagePrepaidConsumption = cb => {
    const { filter, sorted } = this.state;
    const { getAllUsageConsumptionReport } = this.props;
    const newFilter = cloneDeep(filter);
    if (!newFilter.startPeriod) {
      newFilter.startPeriod = moment().format('YYYY-MM');
    }
    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter: newFilter,
      sort: !isEmpty(sorted) ? sortUsagePrepaidConsumption[sorted.sortCol][sorted.sortDir] : null,
    };
    getAllUsageConsumptionReport(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAlllistUsagePrepaidConsumption(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { listAllUsagePrepaidConsumption, t } = this.props;
        convertJson2Pdf({
          data: listAllUsagePrepaidConsumption,
          t,
          title: t('reportPage:sidebar.prepaidConsumption').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.prepaidConsumption')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          columnsTable: tableColumnsOutput,
          fontSize: 7,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAlllistUsagePrepaidConsumption(() => {
      const { listAllUsagePrepaidConsumption, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf } = this.state;

      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'USAGE_CONSUMPTION_REPORT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.prepaidConsumption')}`,
          emailBody,
        },
        ['type']
      )})}"}`;
      const formData = new FormData();

      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.prepaidConsumption')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllUsagePrepaidConsumption,
            t,
            columns: tableColumnsOutput,
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllUsagePrepaidConsumption,
          t,
          title: t('reportPage:sidebar.prepaidConsumption').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.prepaidConsumption')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          columnsTable: tableColumnsOutput,
          fontSize: 7,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.prepaidConsumption')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }

      formData.append('graphql', query);
      // formData.append('file', blobToFile(pdfFile, 'attachment'));
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('USAGE_CONSUMPTION_REPORT', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportUsagePrepaidConsumption,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listUsagePrepaidConsumption,
      emails,
      filter,
      exportColumnsSave,
      isOpenModalExportConfig,
    } = this.state;
    const {
      listAllUsagePrepaidConsumption,
      t,
      permissions: { modeGetPrepaidConsumptionReport, modeDownloadReport, modeGetMailReport },
    } = this.props;
    if (!modeGetPrepaidConsumptionReport) return '';
    const exportColumns = exportColumnsSave || {};
    tableColumnsOutput = exportColumns?.targetFields?.items || [];
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[
            { name: t('label.report'), url: RouteNames.report.path },
            { name: t('reportPage:sidebar.prepaidConsumption') },
          ]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.prepaidConsumption')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <UsagePrepaidConsumptionSearchForm onSubmit={this.onHandleSubmitSearch} defaultFilter={filter} />
              </div>
              <div>
                <div className="mt-3 col-md-12 row mb-4 pt-3 pb-3">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    {/* {t('label.outputConfig')} */}
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.prepaidConsumption').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllUsagePrepaidConsumption,
                          t,
                          title: t('reportPage:sidebar.prepaidConsumption').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.prepaidConsumption')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listUsagePrepaidConsumption}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput}
                  data={
                    listUsagePrepaidConsumption && listUsagePrepaidConsumption.length ? listUsagePrepaidConsumption : []
                  }
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

UsagePrepaidConsumption.propTypes = {
  getUsageConsumptionReport: PropTypes.func,
  getAllUsageConsumptionReport: PropTypes.func,
  listAllUsagePrepaidConsumption: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.any),
    PropTypes.objectOf(PropTypes.any),
  ]),
};

UsagePrepaidConsumption.defaultProps = {
  getUsageConsumptionReport: () => {},
  getAllUsageConsumptionReport: () => {},
  listAllUsagePrepaidConsumption: [],
};

const mapStateToProps = createStructuredSelector({
  listUsagePrepaidConsumption: makeGetUsageConsumptionReport() || [],
  listAllUsagePrepaidConsumption: makeGetListAllUsageConsumptionReport() || [],
});
export default withTranslation('common')(
  connect(mapStateToProps, {
    getUsageConsumptionReport,
    getAllUsageConsumptionReport,
    uploadMultiPartFiles,
    getConfigUsagePlatforms,
    saveOutputTemplateByType,
    getOutputTemplateByType,
    onResetDefaultData,
  })(UsagePrepaidConsumption)
);
